import HeroWithLogo from "./heroWithLogo";

export default HeroWithLogo;
